import { createContext } from 'react';

const appContext = {
  user: [],
  auth: [],
  message: [],
  maps: {}
};
export const Context = createContext(appContext);
